import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function NotFound() {
  const { user } = useAuth();

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg, #f9fafb)', padding: 24,
    }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div style={{
          fontSize: '5rem', fontWeight: 800, color: 'var(--primary, #B4827A)',
          lineHeight: 1, marginBottom: 8,
        }}>
          404
        </div>
        <h1 style={{ fontSize: '1.4rem', margin: '0 0 8px', color: 'var(--text, #1e293b)' }}>
          Seite nicht gefunden
        </h1>
        <p style={{ color: 'var(--text-muted, #64748b)', margin: '0 0 32px', fontSize: '0.95rem' }}>
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link
            to={user ? '/dashboard' : '/'}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6, padding: '10px 24px',
              background: 'var(--primary, #B4827A)', color: '#fff', borderRadius: 8,
              textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem',
            }}
          >
            <Home size={16} />
            {user ? 'Zum Dashboard' : 'Zur Startseite'}
          </Link>
          <button
            onClick={() => window.history.back()}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6, padding: '10px 24px',
              background: 'var(--bg-card, #fff)', color: 'var(--text, #1e293b)',
              border: '1px solid var(--border, #e2e8f0)', borderRadius: 8,
              cursor: 'pointer', fontWeight: 500, fontSize: '0.9rem',
            }}
          >
            <ArrowLeft size={16} />
            Zurück
          </button>
        </div>
      </div>
    </div>
  );
}
